/**
 * Адреса связей товаров Platform (`CatalogLinksController`, FIX-A2). Литерал
 * `/api/` законен только в файлах `api/urls.ts` (eslint). rid и ключи карточек —
 * ввод человека: кодируются.
 */
const BASE = '/api/platform/v1/catalog'

export const PLATFORM_CATALOG_URLS = {
  links: `${BASE}/links`,
  unlink: (productId: string, resourceId: string) =>
    `${BASE}/products/${encodeURIComponent(productId)}/identities/${encodeURIComponent(resourceId)}/unlink`,
} as const
